import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { CoachMatchingPublicScreen } from "@/modules/coaching/coach-matching/screens/CoachMatchingPublicScreen";
import { SHORT_URL_SOURCES } from "@/modules/tracking/consts/ShortUrl";

const coachMatchingPublicSearchSchema = z.object({
  email: z.string().trim().email().optional().catch(undefined),
  name: z.string().trim().min(1).optional().catch(undefined),
  source: z.enum(SHORT_URL_SOURCES).optional().catch(undefined),
});

function CoachMatchingPublicRoute() {
  const { email, name, source } = Route.useSearch();

  return (
    <CoachMatchingPublicScreen
      memberName={name}
      memberEmail={email}
      source={source}
    />
  );
}

export const Route = createFileRoute("/coach-matching")({
  validateSearch: coachMatchingPublicSearchSchema,
  component: CoachMatchingPublicRoute,
});
